/**
 * Panel filtrów kolekcji — zwijanie grup, wyszukiwanie, suwak ceny (product-card__price)
 */
document.addEventListener('DOMContentLoaded', function () {
  var panel = document.querySelector('.filters-panel');
  if (!panel) return;

  panel.querySelectorAll('.filter-group__header').forEach(function (header) {
    header.addEventListener('click', function () {
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', isExpanded ? 'false' : 'true');
    });
  });

  panel.querySelectorAll('.filter-search-input').forEach(function (input) {
    input.addEventListener('input', function () {
      var searchFor = this.dataset.searchFor;
      var optionsContainer = document.querySelector('[data-options-for="' + searchFor + '"]');
      if (!optionsContainer) return;
      var searchTerm = this.value.toLowerCase();
      optionsContainer.querySelectorAll('.filter-option').forEach(function (option) {
        var label = option.querySelector('.filter-option__label');
        if (label) {
          option.style.display = label.textContent.toLowerCase().indexOf(searchTerm) !== -1 ? 'flex' : 'none';
        }
      });
    });
  });

  var priceMin = document.getElementById('price-min');
  var priceMax = document.getElementById('price-max');
  var priceMinDisplay = document.getElementById('price-min-display');
  var priceMaxDisplay = document.getElementById('price-max-display');
  var priceRangeFill = document.getElementById('price-range-fill');

  if (!priceMin || !priceMax) return;

  var minLimit = parseFloat(priceMin.min) || 0;
  var maxLimit = parseFloat(priceMax.max) || 100000;

  function parsePriceFromCard(card) {
    var cents = card.getAttribute('data-price-cents');
    if (cents !== null && cents !== '') {
      var n = parseInt(cents, 10);
      if (!isNaN(n)) return n / 100;
    }
    var priceEl = card.querySelector('.product-card__price--sale') || card.querySelector('.product-card__price');
    if (!priceEl) return null;
    var text = priceEl.textContent.trim().replace(/\s/g, '');
    var num = text.replace(/[^\d,.]/g, '').replace(',', '.');
    var v = parseFloat(num);
    return isNaN(v) ? null : v;
  }

  function updatePriceSlider() {
    var min = parseInt(priceMin.value, 10) || minLimit;
    var max = parseInt(priceMax.value, 10) || maxLimit;
    var minVal = Math.min(min, max);
    var maxVal = Math.max(min, max);

    var range = maxLimit - minLimit;
    if (range <= 0) return;

    var leftPercent = ((minVal - minLimit) / range) * 100;
    var rightPercent = ((maxVal - minLimit) / range) * 100;

    if (priceRangeFill) {
      priceRangeFill.style.left = leftPercent + '%';
      priceRangeFill.style.width = Math.max(0, rightPercent - leftPercent) + '%';
    }
    if (priceMinDisplay) priceMinDisplay.textContent = minVal + ' zł';
    if (priceMaxDisplay) priceMaxDisplay.textContent = maxVal + ' zł';
  }

  function applyPriceFilter() {
    var min = Math.min(parseInt(priceMin.value, 10) || 0, parseInt(priceMax.value, 10) || maxLimit);
    var max = Math.max(parseInt(priceMin.value, 10) || 0, parseInt(priceMax.value, 10) || maxLimit);

    document.querySelectorAll('.collection-page__grid .product-card').forEach(function (card) {
      var price = parsePriceFromCard(card);
      if (price === null) {
        card.style.display = '';
        return;
      }
      if (price >= min && price <= max) {
        card.style.display = '';
      } else {
        card.style.display = 'none';
      }
    });
  }

  var priceTimeout = null;
  function handlePriceChange() {
    updatePriceSlider();
    clearTimeout(priceTimeout);
    priceTimeout = setTimeout(applyPriceFilter, 150);
  }

  priceMin.addEventListener('input', handlePriceChange);
  priceMax.addEventListener('input', handlePriceChange);
  priceMin.addEventListener('change', applyPriceFilter);
  priceMax.addEventListener('change', applyPriceFilter);
  updatePriceSlider();
});
